// Adds an event to the history pushState method
//
// Currently there isn't an event that fires when
// history.pushState or history.replaceState are called.
// The native "onpopstate" event is only called when the user
// navigates pages and not when the JS pushes or replaces state
(function(history) {
	// Make sure this function isn't native or already defined
	if(typeof history.onpushstate !== "function") {
		// Create the event.
		var onpushstate = document.createEvent('Event');
		// Define the event name.
		onpushstate.initEvent('pushstate', true, true);
		// Define the history event handler
		history.onpushstate = function() {
			onpushstate.arguments = arguments;
			document.dispatchEvent(onpushstate);
		};
	}

    // Make sure this function isn't native or already defined
    if(typeof history.onreplacestate !== "function") {
        // Create the event.
        var onreplacestate = document.createEvent('Event');
        // Define the event name.
        onreplacestate.initEvent('replacestate', true, true);
        // Define the history event handler
        history.onreplacestate = function() {
            onreplacestate.arguments = arguments;
            document.dispatchEvent(onreplacestate);
        };
    }

	history.pushState = function(state, title, url) {
		// call the original pushState prototype
		Object.getPrototypeOf(this).pushState.call(this, state, title, url);
		// Call the change event
		history.onpushstate({
			state: state,
			title: title,
			url: url
		});
	};

    history.replaceState = function(state, title, url) {
        // call the original pushState prototype
        Object.getPrototypeOf(this).replaceState.call(this, state, title, url);
        // Call the change event
        history.onreplacestate({
            state: state,
            title: title,
            url: url
        });
    };

})(window.history);
